import { IconButton, Tooltip } from '@material-ui/core'
import ArchiveIcon from '@material-ui/icons/Archive'
import DownloadIcon from '@material-ui/icons/CloudDownload'
import SortIcon from '@material-ui/icons/Sort'

export const applicantTableOptions = (
  records,
  loading,
  setQuery,
  downloadCsv,
  downloadZipDocs,
  sortByStatus,
  currentFilterStatus
) => {
  return {
    download: false,
    print: false,
    filter: false,
    filterType: 'dropdown',
    selectableRows: 'none',
    responsive: 'scroll',
    elevation: 0,
    maxHeight: 'none',
    search: false,
    pagination: true,
    serverSide: true,
    count: records,
    rowsPerPageOptions: [10, 50, 100, 200],
    sortOrder: sortByStatus ? { name: 'Status', direction: 'asc' } : {},
    textLabels: {
      body: {
        noMatch: loading ? 'Loading...' : 'No data'
      }
    },
    onTableChange: (action, tableState) => {
      switch (action) {
        case 'changeRowsPerPage':
          tableState.page = 0
          break
        default:
      }
    },
    onColumnSortChange: (changedColumn, direction) => {
      // Toggle sortByStatus: true to sort by current filter status, false to disable
      setQuery((prev) => ({ ...prev, sortByStatus: !sortByStatus, page: 0 }))
    },
    onChangeRowsPerPage: (e) => {
      setQuery((prev) => ({ ...prev, limit: e, page: 0 }))
    },
    onChangePage: (e) => {
      setQuery((prev) => ({ ...prev, page: e }))
    },
    customToolbar: () => {
      return (
        <>
          <Tooltip title={sortByStatus ? 'Clear Status Sort' : `Sort by ${currentFilterStatus} status first`}>
            <IconButton
              aria-label='Sort by status'
              onClick={() => {
                setQuery((prev) => ({ ...prev, sortByStatus: !sortByStatus, page: 0 }))
              }}
              style={{
                color: sortByStatus ? '#28a745' : 'inherit'
              }}
            >
              <SortIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title={'Download CSV'}>
            <IconButton
              aria-label={'Download CSV'}
              onClick={() => {
                downloadCsv()
              }}
            >
              <DownloadIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title={'Download CVs as ZIP'}>
            <IconButton
              aria-label={'Download CVs as ZIP'}
              onClick={() => {
                downloadZipDocs()
              }}
            >
              <ArchiveIcon />
            </IconButton>
          </Tooltip>
        </>
      )
    }
  }
}
